// extracted by mini-css-extract-plugin
module.exports = {"sameBoardOperation":"osCxPLi4","title":"nwKRTdxt","content":"oO00fyFB","swiperContent":"LsPrbgX_","icon":"NRlR1pvJ","boardCard":"Vv00tbFM"};